var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list',{attrs:{"nav":"","dense":""}},_vm._l((_vm.menu),function(item,index){return _c('div',{key:index},[(item.key || item.text)?_c('div',{staticClass:"pa-1 mt-2 overline"},[_vm._v(_vm._s(item.key ? _vm.$t(item.key) : item.text))]):_vm._e(),_c('nav-menu',{attrs:{"menu":item.items}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }